import { render, staticRenderFns } from "./newSelectCommodityNum.vue?vue&type=template&id=09189d2c&scoped=true"
import script from "./newSelectCommodityNum.vue?vue&type=script&lang=js"
export * from "./newSelectCommodityNum.vue?vue&type=script&lang=js"
import style0 from "./newSelectCommodityNum.vue?vue&type=style&index=0&id=09189d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09189d2c",
  null
  
)

export default component.exports